module.exports = __webpack_public_path__ + "media/images/categories/headers/education-and-corporate-training-d68434487705fd967f54aa8558e50a16.jpg";